import React, {
    Component
} from 'react';
import './dbTable.css';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import * as Yup from 'yup';
export default class EditForm extends Component{
    constructor(props){
        super(props);
        //values
        this.initialValues=props.initialValues || {};
        this.originalValues=props.originalValues || {};
        this.numInstall=props.numInstall || 0;
        //functions from props
        this.updateFunc=props.updateFunc;
        this.deleteSlot=props.deleteSlot;
        this.state={values:{},
                    install:0};


    }
    componentDidMount(){
        let install=this.initialValues.numInstall;
        this.setState({values:this.initialValues,
                       install:install })
    }
    render(){
        let initialVal=this.initialValues;
        let data=this.originalValues;
        let total=(this.state.values && 
            this.state.values.userData &&
            this.state.values.userData.install_qty)?this.state.values.userData.install_qty:0;
        console.log(this.state.values);
        const validator= Yup.object().shape({
            userData: Yup.object().shape({
                user:Yup.string(),
                pass:Yup.string()
                    .min(2,"Mínimo 2 caracteres")
                    .max(30,"Máximo 30 caracteres")
                    .required("Campo Obligatorio"),
                install_qty:Yup.number()
                    .positive("Sólo números positivos")
                    .integer("Sólo números enteros")
                    .typeError("Sólo valores numéricos")
                    .required("Campo obligatorio")
            })
        });
        return(
            <div>
                <Formik initialValues={initialVal}
                        onSubmit={(values)=>{this.updateFunc(values);
                                             this.setState({values:values});
                                             }}
                        validationSchema={validator}>
                    <Form>
                        
                        <div className="formElement">
                            <label>{data.pass.label}</label>
                            <Field name="userData.pass"
                                className="inputFormik"/>
                            <ErrorMessage name="userData.pass">
                                {(msg)=><p className="pError">{msg}</p>}
                            </ErrorMessage>
                        </div>
                        <div className="formElement">
                            <label>{data.installations_qty.label}</label>
                            <Field name="userData.install_qty"
                                className="inputFormik"/>
                            <ErrorMessage name="userData.install_qty">
                                {(msg)=><p className="pError">{msg}</p>}
                            </ErrorMessage>
                        </div>
                        <div className="formElement">
                                <label>
                                    Permisos:
                                </label>
                        </div>
                        <div className="row-container">
                            {data.features.map((feature,index)=>(
                                <div className="formElement" key={index}>
                                    <label className="checkContainer">
                                        {feature.feature}
                                        <Field type="checkbox" 
                                               name="userFeatures" 
                                               value={feature.feature}/>
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            ))}
                        </div>
                        <button type="submit"> Modificar </button>
                        <div className="formElement">
                            <label style={{"margin-left":"15px"}}>
                                usadas {this.state.install} instalaciones de 
                                {total}
                                <span>
                                    <button type="button" className="side-button" 
                                            onClick={()=>{
                                                this.deleteSlot(data.user.user);
                                                let count=this.state.install-1;
                                                this.setState({install:count});
                                                
                                            }} disabled={(this.state.install===0)?true:false}>
                                        Liberar Slot
                                    </button>
                                </span>
                            </label>
                        </div>
                    </Form>
                </Formik>
                
            </div>
        )
    }
}